import React from 'react';
import { Avatar, Flex } from 'antd';
import { useSuspenseQuery } from '@apollo/client';
import GET_PARTNER_LOGO from './queries/getPartnerLogoUrl';

const avatarSizes = {
  xs: 115,
  sm: 175,
  md: 175,
  lg: 175,
  xl: 120,
  xxl: 200,
};

interface PartnerLogoProps {
  id: string;
}

const PartnerLogo = function ({ id }: PartnerLogoProps) {
  const { data: { partner } = {} } = useSuspenseQuery(GET_PARTNER_LOGO, {
    variables: { id },
  });

  return (
    <Flex flex="auto" justify="center">
      <Avatar
        src={partner?.settings?.appearance?.chatWidgetPhotoUrl}
        size={avatarSizes}
        alt="partner logo"
      />
    </Flex>
  );
};

export default PartnerLogo;
